module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"offerNoAccess":"bietet aktuell keinen Zugriff auf diesen Beitrag.","postWithoutActivePurchasable":"Dieser Beitrag ist momentan keinem aktiven Angebot zugeordnet."},"en":{"offerNoAccess":"currently does not offer access to this item.","postWithoutActivePurchasable":"This post is not linked to an active offer."}}')
  delete Component.options._Ctor
}
